import React from "react";
import { Navigate } from "react-router";

import BillingNew from "../../views/pages/dashboard/client/BillingNew";
import Home from "../../views/pages/dashboard/client/Home";
import Info from "../../views/pages/dashboard/client/Info";
import ReferrerDefault from "../../views/pages/dashboard/client/ReferrerDefault";
import ReferrerPartner from "../../views/pages/dashboard/client/ReferrerPartner";
import ExchangeAccount from "../../views/pages/dashboard/shared/ExchangeAccount";
import NotificationSettings from "../../views/pages/dashboard/shared/NotificationSettings";
import type { RouteProps } from "../routeTypes";
import Redirect from "../utils/Redirect";

export default (props: RouteProps) => {
  const { state, t } = props;
  const { referrerType } = state?.user || {};
  return [
    {
      name: t("routes.home", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      path: "home",
      showOnNav: true,
      icon: "fas fa-home",
      component: <Home />,
    },
    {
      name: t("routes.exchangeAccount", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      path: "exchange-account",
      showOnNav: false,
      icon: "fas fa-robot text-default",
      component: <ExchangeAccount />,
    },
    {
      name: t("routes.exchangeAccount", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      path: "exchange-account/:exchangeAccountId",
      showOnNav: false,
      icon: "fas fa-robot text-default",
      component: <ExchangeAccount />,
    },
    {
      name: t("routes.referralsDefault", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      validate: () => referrerType === "DEFAULT",
      path: "referrals",
      showOnNav: true,
      icon: "fas fa-bullhorn text-default",
      component: <ReferrerDefault />,
    },
    {
      name: t(referrerType === "AMBASSADOR" ? "routes.referralsAmbassador" : "routes.referralsInfluencer", {
        ns: "dashboard",
      }),
      accessRoles: ["Authenticated"],
      validate: () => referrerType === "AMBASSADOR" || referrerType === "INFLUENCER",
      path: "referrals",
      showOnNav: true,
      icon: "fas fa-bullhorn",
      component: <ReferrerPartner />,
    },
    {
      name: t("routes.presentation", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      path: "presentation",
      showOnNav: true,
      icon: "fas fa-image px-1",
      component: <Info />,
    },
    {
      name: t("routes.faqs", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      path: "faqs",
      showOnNav: true,
      icon: "fas fa-info px-1",
      component: <Redirect to="https://investhinks.com/faqs" />,
    },

    // Settings category (at bottom)
    {
      name: t("routes.settings", { ns: "dashboard" }),
      accessRoles: ["Authenticated"],
      path: "settings",
      showOnNav: true,
      icon: "fas fa-cog text-default",
      subRoutes: [
        {
          name: t("routes.managePayments", { ns: "dashboard" }),
          accessRoles: ["Authenticated"],
          path: "billing",
          showOnNav: true,
          component: <BillingNew />,
        },
        {
          name: t("routes.communicationPreferences", { ns: "dashboard" }),
          accessRoles: ["Authenticated"],
          path: "communications",
          showOnNav: true,
          component: <NotificationSettings />,
        },
      ],
    },

    // Legacy route redirect for manage-payments
    {
      path: "manage-payments",
      accessRoles: ["Authenticated"],
      showOnNav: false,
      component: <Navigate to="/settings/billing" replace={true} />,
    },

    // Redirects
    {
      path: "",
      accessRoles: ["Authenticated"],
      index: true,
      component: <Navigate to="/home" replace={true} />,
    },
    {
      path: "*",
      accessRoles: ["Authenticated"],
      index: true,
      component: <Navigate to="/home" replace={true} />,
    },
  ];
};
